import { render, staticRenderFns } from "./leftColSobreA.vue?vue&type=template&id=96773fd2"
import script from "./leftColSobreA.vue?vue&type=script&lang=js"
export * from "./leftColSobreA.vue?vue&type=script&lang=js"
import style0 from "./leftColSobreA.vue?vue&type=style&index=0&id=96773fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports